import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import "./Navbar.css";

export default function Navbar() {
  const { t, lang, toggleLang } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location]);

  const links = [
    { to: "/", label: t.nav.home },
    { to: "/projects", label: t.nav.projects, hidden: true },
    { to: "/services", label: t.nav.services, hidden: true },
    { to: "/about", label: t.nav.about },
    { to: "/contact", label: t.nav.contact },
  ];

  return (
    <nav className={`navbar${scrolled ? " scrolled" : ""}${menuOpen ? " menu-open" : ""}`}>
      <div className="navbar-inner">
        <Link to="/" className="navbar-logo">
          <img src="/logo.png" alt="GDM Installations" className="navbar-logo-img" />
          <span className="navbar-brand">GDM - Wood Installations</span>
        </Link>

        <ul className={`navbar-links${menuOpen ? " open" : ""}`}>
          {links.map((l) => (
            <li key={l.to} className={l.hidden ? "nav-item-hidden" : ""}>
              <Link to={l.to} className={location.pathname === l.to ? "active" : ""}>
                {l.label}
              </Link>
            </li>
          ))}
          <li className="navbar-mobile-cta">
            <Link to="/contact" className="btn-gold">{t.nav.bookConsultation}</Link>
          </li>
        </ul>

        <div className="navbar-actions">
          <button className="lang-toggle" onClick={toggleLang}>
            <span className={lang === "IT" ? "active" : ""}>IT</span>
            <span className="divider">|</span>
            <span className={lang === "EN" ? "active" : ""}>EN</span>
          </button>
          <Link to="/contact" className="btn-gold navbar-cta">{t.nav.bookConsultation}</Link>
          <button className={`hamburger${menuOpen ? " open" : ""}`} onClick={() => setMenuOpen(!menuOpen)}>
            <span/><span/><span/>
          </button>
        </div>
      </div>
    </nav>
  );
}
